import React, { useEffect, useState, useCallback } from 'react';
import { ShowPlanCartList, DeletPlanCartItem, AddplanSubscription } from '../../../Services/UserService/clientService';
import Content from '../../../components/Contents/Content';
import { NotepadText } from 'lucide-react';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';
import { loadScript } from "../../../../Utils/Razorpayment";
import { basicsettinglist } from "../../../Services/Admin/Admin";
import Kyc from '../Profile/Kyc';
import { GetUserData } from '../../../Services/UserService/User';
import ReusableModal from '../../../components/Models/ReusableModal';
import ReusableModal1 from '../../../components/Models/ReusableModal1';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../Utils/Loader';


const ServiceCart = () => {

    const token = localStorage.getItem('token');
    const userid = localStorage.getItem('id');
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [finalPrice, setFinalPrice] = useState(0);
    const [getkey, setGetkey] = useState([]);
    const [company, setCompany] = useState([]);
    const [allKey, setAllKey] = useState([])
    const [kycStatus, setKycStatus] = useState("")
    const [userdata, setUserdata] = useState([]);
    const [viewmodel2, setViewModel2] = useState(false);
    const [viewmodel3, setViewModel3] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [kyckey, setKyckey] = useState([])
    const [autoPaymentTriggered, setAutoPaymentTriggered] = useState(false);

    const fullUrl = window.location.href
    const queryString = fullUrl.split("?").slice(1).join("&");
    const searchParams = new URLSearchParams(queryString);
    const urlPlanId = searchParams.get("planid");


    const clearUrlParams = () => {
        const currentUrl = window.location.href;
        const baseUrl = currentUrl.split('?')[0];
        window.history.replaceState({}, document.title, baseUrl);


        const hashPart = window.location.hash.split('?')[0];
        window.location.hash = hashPart;
    };

    useEffect(() => {
        planList();
        getkeybydata();
        fetchUserData();
    }, []);


    useEffect(() => {
        if (!loading &&
            !autoPaymentTriggered &&
            urlPlanId &&
            cartItems.length > 0 &&
            getkey &&
            company &&
            finalPrice > 0) {

            setAutoPaymentTriggered(true);
            setTimeout(() => {
                handleShowModal(cartItems);
            }, 500);
        }
    }, [loading, cartItems, getkey, company, finalPrice, urlPlanId, autoPaymentTriggered]);




    const fetchUserData = async () => {
        try {
            const userData = await GetUserData(userid, token);
            if (userData && userData.data) {
                setUserdata(userData.data)
            }
        } catch (error) {
            showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
        }
    }



    const handleShowModal = (item) => {
        if (kycStatus == 1 && (userdata?.kyc_verification == 0 || userdata?.kyc_verification == 2)) {
            setViewModel2(true)
            setKyckey(item[0]?._id)
        } else {
            AddPlanSubscribeAddToCart(item)
        }
    };




    const getkeybydata = async () => {
        try {
            const response = await basicsettinglist();
            if (response.status) {
                setGetkey(response?.data[0]?.razorpay_key);
                setCompany(response?.data[0]?.from_name);
                setAllKey(response.data[0])
                setKycStatus(response?.data[0].kyc)
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };




    const planList = async () => {
        try {
            setLoading(true);
            const response = await ShowPlanCartList(userid, token);
            if (response.status) {
                setCartItems(response.data);
            } else {
                setCartItems([])
            }
        } catch (err) {
            console.log('Error fetching cart:', err);
        } finally {
            setLoading(false);
        }
    };




    const handleDelete = async (item) => {
        try {
            const confirmed = await showCustomAlert(
                "confirm",
                "Do you want to remove this item? This action cannot be undone."
            );

            if (!confirmed.isConfirmed) return;

            const data = {
                client_id: userid,
                id: item?._id,
            };

            const response = await DeletPlanCartItem(data, token);

            if (response.status) {
                showCustomAlert("Success", response.message);
                planList();
            }
        } catch (error) {
            showCustomAlert("error", "There was an error deleting the cart.");
        }
    };




    const AddPlanSubscribeAddToCart = async (item) => {
        try {
            if (!window.Razorpay) {
                await loadScript("https://checkout.razorpay.com/v1/checkout.js");
            }

            const Price = Math.round(finalPrice * 100);
            const options = {
                key: getkey,
                amount: Price,
                name: company,
                currency: "INR",
                handler: async function (response1) {
                    setIsLoading(true);
                    const data = {
                        plan_ids: item.map(items => items?.plan_id?._id).filter(id => id),
                        client_id: userid,
                        coupon_code: 0,
                        orderid: response1?.razorpay_payment_id,
                        discount: 0,
                        price: Price,
                    };

                    try {
                        const response2 = await AddplanSubscription(data, token);
                        setIsLoading(false);
                        if (response2?.status) {
                            clearUrlParams();
                            if (kycStatus == 2 && userdata?.kyc_verification == 0) {
                                setViewModel3(true);
                            } else {
                                navigate("/user/thankyou", {
                                    state: {
                                        planType: data,
                                    },
                                });
                            }
                        }
                    } catch (error) {
                        console.error("Error while adding plan subscription:", error);
                        setIsLoading(false);
                    }
                },
                prefill: {},
                theme: {
                    color: "#F37254",
                },
                modal: {
                    ondismiss: function () {
                        if (urlPlanId) {
                            clearUrlParams();
                            setAutoPaymentTriggered(false);
                        }
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("Subscription error:", error);
        }
    };

    const totalPrice = cartItems?.reduce((sum, item) => sum + (item.plan_id?.price || 0), 0);
    const gstAmount = (totalPrice / 100) * 18
    const finalAmount = totalPrice + gstAmount;

    useEffect(() => {
        setFinalPrice(Number(finalAmount));
    }, [cartItems]);

    if (isLoading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '100vh' }}>
                <Loader />
            </div>
        );
    }

    return (
        <Content
            Page_title="Cart"
            backbutton_status={true}
            backbutton_title="Back"
            button_status={false}
        >
            <div className="container mt-4">
                {loading && <div className="text-center"><div className="spinner-border text-primary" role="status"></div></div>}

                {!loading && cartItems.length > 0 && (
                    <div className="container" style={{ maxHeight: "35vh", overflowY: "auto" }}>
                        {cartItems?.map((item, index) => (
                            <div key={index} className="card p-3 mb-3 shadow-sm position-relative">
                                <button
                                    className="btn btn-danger position-absolute"
                                    style={{
                                        top: "0px",
                                        right: "-2px",
                                        borderRadius: "15%",
                                        width: "40px",
                                        height: "30px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                    onClick={() => handleDelete(item)}
                                >
                                    <i className="bi bi-trash" style={{ fontSize: "18px" }}></i>
                                </button>

                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-center align-items-center bg-success rounded-circle" style={{ width: "60px", height: "60px" }}>
                                        <NotepadText size={30} style={{ color: "white" }} />
                                    </div>

                                    <div className="ms-3">
                                        <h5 className="mb-1"><b>{item.plan_id?.category?.title || 'No Title'}</b></h5>
                                        <p className="mb-1" style={{ color: "#a6a6a6" }}>Validity: {item.plan_id?.validity || 'No Validity'}</p>
                                        <p className="fw-bold" style={{ color: "#00e600" }}>₹{item.plan_id?.price?.toLocaleString() || 'No Price'}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {!loading && cartItems.length === 0 ? (
                    <div className="text-center mt-5">
                        <img
                            src="/assets/images/nodata.png"
                            alt="No Records Found"
                            style={{ maxWidth: "300px" }}
                        />
                    </div>
                ) : (
                    <div className="container">
                        <h4 className="mt-4 text-light" ><b>Plan Summary</b></h4>
                        {!loading && cartItems.length > 0 && (
                            <div className="card mt-0 " style={{ border: "1px solid primary" }}>
                                <div className="card-body text-light">
                                    <div className="d-flex justify-content-between">
                                        <strong>Total:</strong> <span className="fs-5">₹{totalPrice.toLocaleString()}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <strong>GST (18%):</strong> <span>₹{gstAmount.toLocaleString()}</span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between fw-bold fs-5">
                                        <strong>Grand Total:</strong> <span>₹{(totalPrice + gstAmount).toLocaleString()}</span>
                                    </div>
                                    <div className="text-center mt-3">
                                        <button
                                            className="btn btn-primary w-100 fw-bold"
                                            onClick={() => handleShowModal(cartItems)}
                                            disabled={urlPlanId && autoPaymentTriggered}
                                        >
                                            {urlPlanId && autoPaymentTriggered ? 'Processing...' : 'Buy Now'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <ReusableModal
                show={viewmodel2}
                onClose={() => setViewModel2(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel2(false);
                        }}
                        type="servicecart"
                        kyckey={kyckey}
                    />
                }
                size="lg"
            />

            <ReusableModal1
                show={viewmodel3}
                onClose={() => setViewModel3(false)}
                title={<>KYC</>}
                body={
                    <Kyc
                        onSuccess={() => {
                            setViewModel3(false);
                        }}
                        type="servicecart"
                    />
                }
                disableClose={false}
                size="lg"
            />

        </Content>
    );
};

export default ServiceCart;